import { cartList, addCart, editCart } from '../api/index.js'
import store from './index.js'
if (localStorage.getItem('userInfo')) {
    var token = JSON.parse(localStorage.getItem('userInfo')).token
    var header = { 'Content-Type': 'application/json', 'token': token, 'platform': 'H5' }
}
const actions = {
    // 购物车数据（查）
    getCartList({
        commit,
        state
    }) {
        return new Promise((resolve, reject) => {
            console.log(commit, 'pppppp')
            cartList({}, header).then(res => {
                let cartData = res.data;
                cartData.map(item => {
                    item.checked = true;
                })
                localStorage.setItem('cartNum', cartData.length)
                commit('cartNum')
                commit('cartList', cartData);
                resolve(res)
            })

        })
    },
    // 添加到购物车（增）
    addCartGoods({
        commit
    }, data) {
        return new Promise((resolve, reject) => {
            addCart(data, header).then(res => {
                store.dispatch('getCartList');
                resolve(res)
            })
        })
    },
    // 修改购物车商品数量（改）|| 删除购物车商品（删）
    changeCartList({
        commit,
        state,
        dispatch
    }, param) {
        console.log(param);
        return new Promise((resolve, reject) => {
            editCart(param, header).then(res => {
                if (param.act === 'delete' && res.code === 1) {
                    store.dispatch('getCartList');

                }
                resolve(res)
                    //commit('cartList')
            })





            // http('cart.edit', {
            // 	cart_list: param.ids,
            // 	value: param.goodsNum || null,
            // 	act: param.art
            // }).then(res => {
            // 	if (param.art === 'delete' && res.code === 1) {
            // 		store.dispatch('getCartList');
            // 	}
            // 	resolve(res)
            // 	commit('checkCartList');
            // }).catch(e => {
            // 	reject(e)
            // })
        })
    },
}
export default actions


// WEBPACK FOOTER //
// ./src/store/actions.js